module.exports = __webpack_public_path__ + "img/netherlands.c5bd0a4.webp";